import React from 'react'
import { Spacer, SpaceTokens } from '@red-ui/components'

type SpacerSize = 'sm' | 'md' | 'lg' | 'xl'

type InlineSpacerProps = {
  fields: { spacerSize: SpacerSize }
}

const getSpacerSize = (spacerSize: SpacerSize): SpaceTokens => {
  const spacerSizeMap = {
    sm: '$1',
    md: '$2',
    lg: '$4',
    xl: '$8',
  }
  return spacerSizeMap[spacerSize] ?? '$4'
}

export const InlineSpacer = ({ fields: { spacerSize } }: InlineSpacerProps) => (
  <Spacer size={getSpacerSize(spacerSize)} minHeight={0} maxHeight="$5" $mobile={{ display: 'none' }} />
)
